import { Audience } from '.';

// Task: 5294949 - Remove usage of ContainerEnvironment
/**
 * @deprecated Replaced by Environment on 7/21/2021, being kept in place for backwards compatibility
 */
export enum ContainerEnvironment {
  Prod = 'Prod',
  Dogfood = 'Dogfood',
  Staging = 'Staging',
  Gcc = 'Gcc',
  Local = 'Local'
}

export type DeploymentRing = 'Prod' | 'Dogfood' | 'Staging' | 'Gcc';
export type UnmappedAudiences = Extract<Audience, 'SyntheticTraffic' | 'Automation' | 'Local'>;
export type MappedAudiences = Exclude<Audience, UnmappedAudiences>;

export type Environment =
  | { audience: MappedAudiences; ring?: undefined }
  | { audience: UnmappedAudiences; ring: DeploymentRing };
